import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { IntegratedIReckonRoomEffects } from './integrated-ireckon-room.effects';
import { integratedIReckonRoomReducer } from './integrated-ireckon-room.reducer';

export const provideIntegratedIReckonRoomStore = () => [
  provideState('integratedIReckonRoom', integratedIReckonRoomReducer),
  provideEffects([IntegratedIReckonRoomEffects]),
];
